module.exports = __webpack_public_path__ + "img/banner3.dc9d8aa7.png";